const APSoutheast1Countries = new Set([
  'AUS',
  'HKG',
  'IDN',
  'IND',
  'JPN',
  'KOR',
  'MAC',
  'MYS',
  'NZL',
  'PHL',
  'SGP',
  'THA',
  'TWN',
]);

const CNNorthwest1Countries = new Set([
  'CHN'
]);

const EUWest1Countries = new Set([
  'ALB',
  'AND',
  'ARE',
  'ARM',
  'AUT',
  'AZE',
  'BEL',
  'BGR',
  'BHR',
  'BIH',
  'BLR',
  'CHE',
  'CNI',
  'CYP',
  'CZE',
  'DEU',
  'DNK',
  'EGY',
  'ESP',
  'EST',
  'FIN',
  'FRA',
  'GBR',
  'GEO',
  'GRC',
  'HRV',
  'HUN',
  'IRL',
  'ISR',
  'ITA',
  'JOR',
  'KAZ',
  'KEN',
  'KGZ',
  'KWT',
  'LBN',
  'LTU',
  'LVA',
  'MAR',
  'MDA',
  'MKD',
  'MNE',
  'NLD',
  'NOR',
  'OMN',
  'POL',
  'PRT',
  'QAT',
  'ROU',
  'RUS',
  'SAU',
  'SRB',
  'SVK',
  'SVN',
  'SWE',
  'TKM',
  'TUN',
  'TUR',
  'UKR',
  'UZB',
  'ZAF',
]);

const SAEast1Countries = new Set([
  'ARG',
  'BRA',
  'CHL',
  'MEX',
  'URY',
]);

const USEast1Countries = new Set([
  'CAN',
  'USA',
]);

module.exports = {
  APSoutheast1Countries, CNNorthwest1Countries, EUWest1Countries, SAEast1Countries, USEast1Countries,
};
